import React from 'react';
import { useHistory } from 'react-router-dom';
import { clsx } from '@components/Provider';
import { LOGO_MEDIUM } from '@assets';
import StageChipPresenter from '@components/Gnb/StageChipPresenter';
import { AppBar, Drawer, useTheme, useMediaQuery } from '@material-ui/core';
import { useStyles } from './useStyles';

interface Props {
  gnbTabs?: React.ReactNode;
  extraBtn?: React.ReactNode;
  contentShift?: boolean;
  leftSideDrawer?: React.ReactNode;
  rightSideDrawer?: React.ReactNode;
  bottomNav?: React.ReactNode;
  isChatDetail?: boolean;
  fullHeight?: boolean;
}

const CommonLayoutPresenter: React.FC<Props> = ({
  gnbTabs,
  extraBtn,
  contentShift,
  leftSideDrawer,
  rightSideDrawer,
  bottomNav,
  isChatDetail,
  fullHeight = false,
  children
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const history = useHistory();
  const classes = useStyles({
    fullHeight: fullHeight,
    matches: matches
  });
  const isHome = history.location.pathname === '/';

  return (
    <div className={classes.root}>
      {!matches && (
        <AppBar
          elevation={0}
          position="fixed"
          className={clsx(classes.appBar, 'gnb-desktop-logo')}
        >
          <div className={classes.appbarTitle}>
            <div
              className={clsx(classes.logo, 'desktop-logo')}
              onClick={() => {
                history.push('/');
              }}
            >
              <div className="capaBackground"></div>
              <img className="capaLogo" src={LOGO_MEDIUM} alt="Logo" />
              <StageChipPresenter />
            </div>
            {gnbTabs}
          </div>
          {extraBtn}
        </AppBar>
      )}
      {leftSideDrawer ? (
        <Drawer
          variant="persistent"
          anchor="left"
          open={true}
          PaperProps={{ id: 'request-list-tab-one' }}
          classes={{
            paper: clsx(classes.leftSideDrawerPaper, {
              [classes.leftSideDrawerBottomPadding]: bottomNav ? true : false
            })
          }}
        >
          {leftSideDrawer}
        </Drawer>
      ) : null}
      <main className={classes.main}>
        <div
          className={clsx(classes.contentHeaderMargin, 'contentHeaderMargin')}
        ></div>
        <div
          className={clsx(isHome ? classes.homeContent : classes.content, {
            [classes.contentShift]: contentShift,
            [classes.contentShiftRight]: isChatDetail
          })}
        >
          {children}
        </div>
      </main>
      {bottomNav}
      {rightSideDrawer}
    </div>
  );
};

export default CommonLayoutPresenter;
